module.exports = __webpack_public_path__ + "img/animation4.89f91376.png";